import AbstractVertical from './AbstractVertical'

export default class Event extends AbstractVertical {

  readonly name: string = 'event'
  readonly title: string = 'Event'
  readonly color: string = '#8b6c27'
  readonly sortWeight: number = 60

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'editInventory',
    'entryAndExitHours',
    'eventTiers',
    'showOnUniversalInventoryCalendar',
  ]

}
